import { ESdChangeReason, EWFDueUnit, IWorkFlow } from "@kuika/kuika-cl-model";
import _ from "lodash";
import type { FocusEvent } from "react";
import { withSD } from "../../../../shared/hoc/screen-design-consumer";
import { withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import KuikaInput from "../../../ui-kit/kuika-input/kuika-input";
import "./workflow-base-properties.scss";
import { WorkflowDue } from "./wf-utils/workflow-due";

export interface IWorkFlowBasePropertiesState {}

export interface IWorkFlowBasePropertiesProps {
  wf: IWorkFlow | undefined;
}

class WorkFlowBaseProperties extends PureSdComponent<IWorkFlowBasePropertiesProps, IWorkFlowBasePropertiesState> {
  constructor(props: IWorkFlowBasePropertiesProps) {
    super(props);
    this.state = {};
  }

  DueChangeHandler = (value: EWFDueUnit | number, field: "unit" | "value"): void => {
    const currentWF: IWorkFlow | undefined = this.props.sd.selectedWf;
    if (currentWF && currentWF.nodes && currentWF.nodes) {
      if (!currentWF.nodes.dueIn)
        currentWF.nodes.dueIn = {
          dueUnit: EWFDueUnit.Days,
          dueValue: 1
        };

      if (field === "unit") {
        currentWF.nodes.dueIn.dueUnit = value as EWFDueUnit;
      } else if (field === "value") {
        currentWF.nodes.dueIn.dueValue = value;
      }
      this.props.sd.saveWorkFlow(currentWF);
    }
  };

  wfDescriptionChangedHandler = (e: FocusEvent<HTMLTextAreaElement>): void => {
    const currentWF: IWorkFlow | undefined = this.props.sd.selectedWf;
    if (currentWF && currentWF.nodes) {
      currentWF.nodes.description = e.target.value;
      this.props.sd.saveWorkFlow(currentWF);
    }
  };

  render(): JSX.Element {
    if (this.props.wf) {
      const description: string | undefined = _.clone(this.props.wf.nodes?.description);
      return (
        <div className="kuika-wf-process">
          <section className="kuika-wf-process__section">
            <div className="kuika-wf-process__section-head">
              <span className="kuika-wf-process__section-title">Process Description</span>
            </div>
            <KuikaInput
              type="textarea"
              rows={3}
              data-testid="processDescriptionInput"
              defaultValue={description}
              placeholder="Add a description for this process"
              onBlur={(e) => this.wfDescriptionChangedHandler(e)}
            />
          </section>

          <section className="kuika-wf-process__section">
            <div className="kuika-wf-process__field-row">
              <span className="kuika-wf-process__field-label">Process Due</span>
              <span className="kuika-wf-process__field-control">
                <WorkflowDue
                  due={this.props.wf.nodes?.dueIn}
                  onDueUnitChange={(val) => this.DueChangeHandler(val, "unit")}
                  onDueValueChange={(val) => this.DueChangeHandler(val, "value")}
                  loading={false}
                  id="process-due"
                ></WorkflowDue>
              </span>
            </div>
          </section>
        </div>
      );
    }
    return <></>;
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (changeReason === ESdChangeReason.SaveWorkflow || changeReason === ESdChangeReason.ClickWfDesignXmlNode) {
      return true;
    }
    return false;
  };
}

const workFlowBaseProperties = withContext<IWorkFlowBasePropertiesProps>(
  withSD<IWorkFlowBasePropertiesProps>(WorkFlowBaseProperties)
);
export { workFlowBaseProperties as WorkFlowBaseProperties };
